// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".return-disclaimer[data-v-e4dca362]{font-size:10px;font-size:.625rem;color:hsla(0,0%,100%,.7)}", ""]);
// Exports
module.exports = exports;
